import { render } from "./dealer.vue?vue&type=template&id=4e6f9dab&scoped=true"
import script from "./dealer.vue?vue&type=script&lang=js"
export * from "./dealer.vue?vue&type=script&lang=js"

import "./dealer.vue?vue&type=style&index=0&id=4e6f9dab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6f9dab"]])

export default __exports__